import type { CmcdData } from './CmcdData.js';

/**
 * A CMCD key.
 *
 * @group CMCD
 *
 * @beta
 */
export type CmcdKey = keyof CmcdData;
